<template>
  <div>
    <blocks-view v-if="page" :page="page" resource="bookings" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      uid: this.$store.getters.uid
    }
  },

  computed: {
    page() {
      return this.$store.getters['bookings/page'].main
    }
  },

  async created() {
    await this.$store.dispatch('bookings/page', 1)
  }
}
</script>
